export default __webpack_public_path__ + "static/DSC_0064-729e1fd589ade28aa59f5ff1e852a026.jpg";